import {CustomerMypageState} from "../store/customer_mypage_state";
import {Reducer} from "redux";
import {
    CustomerMypageAction,
    CustomerMypageActionType,
    ICallbackGetMeCustomerAction,
    ICallbackUpdateCustomerAction,
} from "../action/customer_mypage_action";

const initialState: CustomerMypageState = {
    customer: null,
    jobCareers: [],
    pastCaseProjects: [],
    blobURL: "",
    isLoading: false,
};

const customerMypageReducer: Reducer<CustomerMypageState> = (state = initialState, action: CustomerMypageAction): CustomerMypageState => {
    switch (action.type) {
        case CustomerMypageActionType.REQUEST_GET_ME_CUSTOMER: {
            return Object.assign({}, state, {
                customer: state.customer,
                jobCareers: state.jobCareers,
                isLoading: true,
            })
        }
        case CustomerMypageActionType.CALLBACK_GET_ME_CUSTOMER: {
            const _action = action as ICallbackGetMeCustomerAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    customer: _action.item ? _action.item.customer : null,
                    jobCareers: _action.item ? _action.item.jobCareers : [],
                    pastCaseProjects: _action.item ? _action.item.pastCaseProjects : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    customer: state.customer,
                    jobCareers: state.jobCareers,
                    isLoading: false,
                })
            }
        }

        case CustomerMypageActionType.REQUEST_UPDATE_CUSTOMER: {
            return Object.assign({}, state, {
                customer: state.customer,
                jobCareers: state.jobCareers,
                isLoading: true,
            })
        }
        case CustomerMypageActionType.CALLBACK_UPDATE_CUSTOMER: {
            const _action = action as ICallbackUpdateCustomerAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    customer: _action.item ? _action.item.customer : null,
                    jobCareers: _action.item ? _action.item.jobCareers : [],
                    pastCaseProjects: _action.item ? _action.item.pastCaseProjects : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    customer: state.customer,
                    jobCareers: state.jobCareers,
                    isLoading: false,
                })
            }
        }


        case CustomerMypageActionType.REQUEST_UPDATE_PASSWORD: {
            return Object.assign({}, state, {
                customer: state.customer,
                jobCareers: state.jobCareers,
                isLoading: true,
            })
        }
        case CustomerMypageActionType.CALLBACK_UPDATE_PASSWORD: {
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    customer: state.customer,
                    jobCareers: state.jobCareers,
                    isLoading: false,
                })
            } else {
                return Object.assign({}, state, {
                    customer: state.customer,
                    jobCareers: state.jobCareers,
                    isLoading: false,
                })
            }
        }

        case CustomerMypageActionType.REQUEST_UPDATE_EMAIL: {
            return Object.assign({}, state, {
                customer: state.customer,
                jobCareers: state.jobCareers,
                isLoading: true,
            })
        }
        case CustomerMypageActionType.CALLBACK_UPDATE_EMAIL: {
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    customer: state.customer,
                    jobCareers: state.jobCareers,
                    isLoading: false,
                })
            } else {
                return Object.assign({}, state, {
                    customer: state.customer,
                    jobCareers: state.jobCareers,
                    isLoading: false,
                })
            }
        }
        case CustomerMypageActionType.REQUEST_GENERATE_CUSTOMER_PDF: {
            return Object.assign({}, state, {
                isLoading: true,
            })
        }
        case CustomerMypageActionType.CALLBACK_GENERATE_CUSTOMER_PDF: {
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    blobURL: action.item ? action.item.blobURL : "",
                    isLoading: false,
                })
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                })
            }
        }

        case CustomerMypageActionType.REQUEST_DESTROY_CUSTOMER_PDF: {
            return Object.assign({}, state, {
                isLoading: true,
            })
        }
        case CustomerMypageActionType.CALLBACK_DESTROY_CUSTOMER_PDF: {
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    blobURL: initialState.blobURL,
                    isLoading: false,
                })
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                })
            }
        }

        default:
            return state;
    }
};

export default customerMypageReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/customer_mypage_reducer.ts